module.exports = __webpack_public_path__ + "static/media/pizza-logo.f3327011.svg";